// store.js
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import userReducer from "./reducers/index";
import CurrencyReducer from "./reducers/currencyReducer";
import rowsReducer from "./reducers/rowReducer";
import comparisonReducer from "./reducers/comparisonReducers";
import rightReducer from "./reducers/rightReduser";
import companyReducer from "./reducers/companyReducer";

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userAuth', 'Currency', 'cart', 'table', 'orderEdit', 'comboCart', 'addons', 'employeData', 'rows', 'comparison', 'userRights','company']
};

const appReducer = combineReducers({
  userAuth: userReducer,
  Currency: CurrencyReducer,
  rows: rowsReducer,
  comparison: comparisonReducer,
  userRights: rightReducer,
  company: companyReducer,
});

const persistedReducer = persistReducer(persistConfig, appReducer);

export const configureReduxStore = () => {
  const store = configureStore({
    reducer: persistedReducer,
  });

  const persistor = persistStore(store);

  return { store, persistor };
};
